

// import React, { useEffect, useState } from "react";
// import { motion } from "framer-motion";

// function Shlokas() {
//   const [shlokas, setShlokas] = useState([]);

//   useEffect(() => {
//     fetch("/bhaktamar.json")
//       .then((res) => res.json())
//       .then((data) => setShlokas(data))
//       .catch((err) => console.error("Error loading shlokas:", err));
//   }, []);

//   return (
//     <motion.div
//       initial={{ opacity: 0 }}
//       animate={{ opacity: 1 }}
//       transition={{ duration: 0.8 }}
//       style={{
//         background:
//           "linear-gradient(180deg, #fff9f3 0%, #fef7e7 40%, #fff 100%)",
//         fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
//         minHeight: "100vh",
//         width: "100%",
//         padding: "50px 5%",
//         boxSizing: "border-box",
//       }}
//     >
//       {/* Header */}
//       <div style={{ textAlign: "center", marginBottom: "40px" }}>
//         <h1
//           style={{
//             color: "#7b0000",
//             fontWeight: "800",
//             fontSize: "3rem",
//             marginBottom: "10px",
//           }}
//         >
//           भक्तामर स्तोत्र — ४८ श्लोक
//         </h1>
//         <p
//           style={{
//             color: "#555",
//             fontStyle: "italic",
//             fontSize: "1.25rem",
//           }}
//         >
//           (संस्कृत श्लोक संग्रह)
//         </p>
//         <div
//           style={{
//             width: "100px",
//             height: "3px",
//             backgroundColor: "#b30000",
//             margin: "12px auto",
//             borderRadius: "2px",
//           }}
//         ></div>
//       </div>

//       {/* Shlokas Grid */}
//       <div
//         style={{
//           display: "grid",
//           gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
//           gap: "30px",
//           justifyItems: "center",
//         }}
//       >
//         {shlokas.map((s) => (
//           <motion.div
//             key={s.id}
//             initial={{ opacity: 0, y: 30 }}
//             whileInView={{ opacity: 1, y: 0 }}
//             viewport={{ once: true }}
//             transition={{ duration: 0.4 }}
//             style={{
//               background: "#fff",
//               borderRadius: "20px",
//               padding: "25px 30px",
//               width: "100%",
//               boxShadow:
//                 "0 4px 25px rgba(0,0,0,0.05), inset 0 0 8px rgba(255,0,0,0.05)",
//               borderLeft: "6px solid #a00000",
//               position: "relative",
//               boxSizing: "border-box",
//               textAlign: "justify",
//               maxWidth: "100%",
//             }}
//           >
//             <div
//               style={{
//                 position: "absolute",
//                 top: "-15px",
//                 left: "-15px",
//                 width: "45px",
//                 height: "45px",
//                 borderRadius: "50%",
//                 backgroundColor: "#a00000",
//                 color: "#fff",
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "center",
//                 fontWeight: "700",
//                 fontSize: "1.1rem",
//                 boxShadow: "0 3px 10px rgba(0,0,0,0.2)",
//               }}
//             >
//               {s.id}
//             </div>

//             <p
//               style={{
//                 color: "#2c2c2c",
//                 fontSize: "1.25rem",
//                 lineHeight: "2.1rem",
//                 whiteSpace: "pre-line",
//               }}
//             >
//               {s.text}
//             </p>
//           </motion.div>
//         ))}
//       </div>

//       {/* 📱 Responsive Design */}
//       <style>
//         {`
//           @media (max-width: 992px) {
//             h1 { font-size: 2.2rem !important; }
//             p { font-size: 1.1rem !important; }
//           }

//           @media (max-width: 576px) {
//             h1 {
//               font-size: 1.7rem !important;
//               line-height: 1.4;
//             }
//             p {
//               font-size: 1rem !important;
//               line-height: 1.8 !important;
//             }
//             div[style*="width: 45px"] {
//               width: 35px !important;
//               height: 35px !important;
//               font-size: 0.9rem !important;
//               top: -10px !important;
//               left: -10px !important;
//             }
//             div[style*="padding: 25px 30px"] {
//               padding: 20px !important;
//             }
//           }
//         `}
//       </style>
//     </motion.div>
//   );
// }

// export default Shlokas;


import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";

function Shlokas() {
  const [shlokas, setShlokas] = useState([]);

  useEffect(() => {
    fetch("/bhaktamar.json")
      .then((res) => res.json())
      .then((data) => setShlokas(data))
      .catch((err) => console.error("Error loading shlokas:", err));
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      style={{
        background: "linear-gradient(180deg, #fffaf3 0%, #fff3e1 50%, #fff 100%)",
        fontFamily: "'Noto Sans Devanagari', 'Poppins', sans-serif",
        minHeight: "100vh",
        width: "100%",
        padding: "60px 5%",
        boxSizing: "border-box",
      }}
    >
      {/* 🌸 Header */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "50px",
          position: "relative",
        }}
      >
        <motion.h1
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            color: "#a00000",
            fontWeight: "800",
            fontSize: "3rem",
            marginBottom: "15px",
            textShadow: "0 2px 10px rgba(255,200,150,0.4)",
          }}
        >
          भक्तामर स्तोत्र — ४८ श्लोक
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          style={{
            color: "#5a3a0e",
            fontStyle: "italic",
            fontSize: "1.25rem",
          }}
        >
          (संस्कृत श्लोक संग्रह)
        </motion.p>

        <motion.div
          initial={{ scaleX: 0 }}
          animate={{ scaleX: 1 }}
          transition={{ duration: 1, delay: 0.4 }}
          style={{
            width: "120px",
            height: "4px",
            background: "linear-gradient(90deg, #b66b00, #ffb347)",
            margin: "15px auto 0",
            borderRadius: "4px",
          }}
        />
      </div>

      {/* 📜 Shlokas Grid */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
          gap: "30px",
          justifyItems: "center",
        }}
      >
        {shlokas.map((s) => (
          <motion.div
            key={s.id}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.4 }}
            style={{
              background: "linear-gradient(145deg, #fffaf3, #fff5e6)",
              borderRadius: "20px",
              padding: "25px 30px",
              width: "100%",
              boxShadow:
                "0 6px 25px rgba(0,0,0,0.05), inset 0 0 10px rgba(255,200,150,0.15)",
              borderLeft: "6px solid #b66b00",
              position: "relative",
              boxSizing: "border-box",
              textAlign: "justify",
              maxWidth: "100%",
              color: "#4b2e05",
              lineHeight: "2.1rem",
            }}
          >
            {/* 🔘 Shloka ID Badge */}
            <div
              style={{
                position: "absolute",
                top: "-15px",
                left: "-15px",
                width: "45px",
                height: "45px",
                borderRadius: "50%",
                background: "linear-gradient(135deg, #b66b00, #ffb347)",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: "700",
                fontSize: "1.1rem",
                boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
              }}
            >
              {s.id}
            </div>

            {/* 📖 Shloka Text */}
            <p
              style={{
                fontSize: "1.25rem",
                whiteSpace: "pre-line",
                margin: 0,
              }}
            >
              {s.text}
            </p>
          </motion.div>
        ))}
      </div>

      {/* 📱 Responsive Design */}
      <style>
        {`
          @media (max-width: 992px) {
            h1 { font-size: 2.2rem !important; }
            p { font-size: 1.1rem !important; }
          }

          @media (max-width: 576px) {
            h1 {
              font-size: 1.7rem !important;
              line-height: 1.4;
            }
            p {
              font-size: 1rem !important;
              line-height: 1.8 !important;
            }
            div[style*="width: 45px"] {
              width: 35px !important;
              height: 35px !important;
              font-size: 0.9rem !important;
              top: -10px !important;
              left: -10px !important;
            }
            div[style*="padding: 25px 30px"] {
              padding: 20px !important;
            }
          }
        `}
      </style>
    </motion.div>
  );
}

export default Shlokas;
